<template>
  <div
    class="relative flex min-h-screen w-full flex-row bg-surface-container-low lg:h-screen lg:overflow-hidden"
  >
    <button
      class="group fixed top-2 left-2 z-70 flex h-12 w-12 items-center justify-center overflow-hidden rounded-full lg:top-16 lg:left-6"
      @click="toggleExpanded"
    >
      <BaseIcon
        size="24"
        class="ease-fast-spatial transition-all duration-200"
        :class="[isExpanded && 'rotate-360deg', !isExpanded && 'rotate-0']"
        >{{ isExpanded ? 'menu_open' : 'menu' }}</BaseIcon
      >
      <BaseStateLayer />
    </button>
    <slot name="sidebar" :is-expanded="isExpanded" :toggle-expanded="toggleExpanded">
      <AppRail :is-expanded="isExpanded" class="z-60" @nav-item-clicked="toggleExpanded" />
    </slot>
    <main class="relative z-40 flex w-full grow flex-col">
      <slot name="app-bar" :is-expanded="isExpanded" :toggle-expanded="toggleExpanded">
        <AppBar :is-expanded="isExpanded" class="z-40" @toggle-menu="toggleExpanded" />
      </slot>
      <div class="grow lg:mr-2 lg:mb-2 lg:overflow-hidden">
        <slot />
      </div>
    </main>

    <BaseScrim v-if="isExpanded" class="z-50 lg:hidden" @click="toggleExpanded" />
  </div>
</template>

<script setup lang="ts">
  import AppBar from '../sidebar/AppBar.vue'
  import AppRail from '../sidebar/AppRail.vue'
  import BaseScrim from '../base/dialog/BaseScrim.vue'
  import BaseIcon from '../base/icon/BaseIcon.vue'
  import BaseStateLayer from '../base/state-layer/BaseStateLayer.vue'
  import { useLocalStorage } from '@vueuse/core'

  interface Props {
    storageKey?: string
    defaultExpanded?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    storageKey: 'app-rail-expanded',
    defaultExpanded: true,
  })

  const isExpanded = useLocalStorage(props.storageKey, props.defaultExpanded)

  const toggleExpanded = () => {
    isExpanded.value = !isExpanded.value
  }
</script>
